export const GET_ALL_CONTACTS_REQUEST = "GET_ALL_CONTACTS_REQUEST";
export const GET_ALL_CONTACTS_SUCCESS = "GET_ALL_CONTACTS_SUCCESS";
export const GET_ALL_CONTACTS_FAIL = "GET_ALL_CONTACTS_FAIL";
export const GET_ALL_CONTACTS_RESET = "GET_ALL_CONTACTS_RESET";

export const GET_SINGLE_CONTACTS_REQUEST = "GET_SINGLE_CONTACTS_REQUEST";
export const GET_SINGLE_CONTACTS_SUCCESS = "GET_SINGLE_CONTACTS_SUCCESS";
export const GET_SINGLE_CONTACTS_FAIL = "GET_SINGLE_CONTACTS_FAIL";
export const GET_SINGLE_CONTACTS_RESET = "GET_SINGLE_CONTACTS_RESET";
